import type { Http } from '../http';
import { endpoints } from '../endpoints';
import type { RequestOptions } from '../types/common';
import type {
  RawCreateBillingRequest,
  RawCreateBillingResponse,
  RawDeleteBillingResponse,
  RawReadBillingResponse,
  RawReadBillingsResponse,
  RawUpdateBillingRequest,
  RawUpdateBillingResponse,
} from '../types/billing';

export function createBillingApi(http: Http) {
  return {
    /** POST /api/v2/billings — 결제수단(빌링) 등록 */
    async create(data: RawCreateBillingRequest): Promise<RawCreateBillingResponse> {
      const res = await http.post<RawCreateBillingResponse>(endpoints.billing.base, data);
      return res.data;
    },

    /** GET /api/v2/billings — 결제수단(빌링) 목록 조회 */
    async list(options?: RequestOptions): Promise<RawReadBillingsResponse> {
      const res = await http.get<RawReadBillingsResponse>(endpoints.billing.base, {
        signal: options?.signal,
      });
      return res.data;
    },

    /** POST /api/v2/billings/{billingId} — 결제수단(빌링) 단건 조회 */
    async read(billingId: string, options?: RequestOptions): Promise<RawReadBillingResponse> {
      const res = await http.post<RawReadBillingResponse>(
        endpoints.billing.byId(billingId),
        undefined,
        { signal: options?.signal },
      );
      return res.data;
    },

    /** PUT /api/v2/billings/{billingId} — 결제수단(빌링) 이름 수정 */
    async update(
      billingId: string,
      data: RawUpdateBillingRequest,
    ): Promise<RawUpdateBillingResponse> {
      const res = await http.put<RawUpdateBillingResponse>(endpoints.billing.byId(billingId), data);
      return res.data;
    },

    /** DELETE /api/v2/billings/{billingId} — 결제수단(빌링) 삭제 */
    async remove(billingId: string): Promise<RawDeleteBillingResponse> {
      const res = await http.delete<RawDeleteBillingResponse>(endpoints.billing.byId(billingId));
      return res.data;
    },
  };
}
